import { Injectable, signal } from '@angular/core';
import { HttpStatusType } from '@shared/modal/modal.types';

@Injectable()
export class ModalService {
    public type = signal<HttpStatusType>('loading');
    public isOpened = signal<boolean>(false);

    public changeToLoading(): void {
        this.changeType('loading');
    }

    public changeToSuccess(): void {
        this.changeType('success');
    }

    public changeToError(): void {
        this.changeType('error');
    }

    public open(): void {
        this.isOpened.set(true);
        this.changeToLoading();
    }

    public close(): void {
        this.changeToLoading();
        this.isOpened.set(false);
    }

    private changeType(type: HttpStatusType): void {
        this.type.set(type);
    }
}
